import { makeCurrentUserQueryKeyPrefix } from 'features/currentUser/currentUserQueries';
import { dataScienceClient } from 'services/backofficeIntegration/http/client/createDataScienceClient';
import { queryEndpoint } from 'services/backofficeIntegration/http/endpointDefinition';
import { createUuidV4 } from 'utils/createUuidV4';

export type ApiClaim = {
  id: string;
  reference: string;
  claim: string;
};

export const httpGetClaimsByText = queryEndpoint({
  makeQueryKey: () => {
    return [...makeCurrentUserQueryKeyPrefix(), 'fact-grabbing', 'claims-by-text'] as const;
  },
  callEndpoint: (text: string) =>
    dataScienceClient
      .post<ApiClaim[]>('/ds-fact-grabbing/claims', {
        text
      })
      .then(response =>
        response.data.map(claim => ({
          // @ts-expect-error The entry doesn't contain an id
          id: createUuidV4(),
          ...claim
        }))
      )
});
